
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"160","height":"160","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"80","cy":"80","r":"80","fill":"#E0E0E0"}}),_c('g',{attrs:{"opacity":".75","fill-opacity":".5"}},[_c('path',{attrs:{"d":"M42.03 75.978h74.462v57.58a.439.439 0 01-.44.442H42.469a.439.439 0 01-.44-.442v-57.58z","fill":"#7A7A7A"}}),_c('path',{attrs:{"d":"M97.812 53.414H63.188L42.03 75.978h74.463l-18.68-22.564z","fill":"#4F4F4F"}}),_c('path',{attrs:{"d":"M49.082 44.388l14.106 9.026L42.03 75.978 26 63.73l23.082-19.34zM111.918 44.388l-14.106 9.026 18.68 22.564L135 63.73l-23.082-19.34z","fill":"#7A7A7A"}}),_c('path',{attrs:{"d":"M72.285 44.85a1.725 1.725 0 00.84-2.221L66.78 27.582a1.717 1.717 0 00-.964-.934 1.699 1.699 0 00-1.339.053l-1.222.583a1.71 1.71 0 00-.889 1.008 1.724 1.724 0 00.109 1.343l7.568 14.462a1.699 1.699 0 002.243.752zM80.24 43.391c.288-.02.557-.152.751-.367a1.13 1.13 0 00.289-.788l-.314-10.711a1.131 1.131 0 00-.754-1.031 1.113 1.113 0 00-.444-.059l-.885.063a1.113 1.113 0 00-.781.403 1.127 1.127 0 00-.252.846l1.198 10.648c.033.288.175.553.397.739.222.186.507.278.795.257zM86.382 47.35c.792.461 1.905.039 2.522-.958L99.86 28.701c.654-1.057.499-2.345-.341-2.834l-1.172-.68c-.84-.49-2.028.018-2.613 1.116L85.95 44.675c-.55 1.035-.36 2.215.432 2.676z","fill":"#999"}})])])
          )
        }
      }
    